import * as React from "react";
import { DialogContent, DialogHeader, DialogTitle, Dialog } from "@/components/ui/dialog";
import { Item } from "@/types/fse";
import { AddGroupModalContentStep1 } from "./components/step1";
import { AddGroupModalContentStep2 } from "./components/step2";

interface Props {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  parentFolderId?: string;
}

export const DocumentGroupCreateModal: React.FC<Props> = ({ setIsOpen, parentFolderId, isOpen }) => {
  const [step, setStep] = React.useState<1 | 2>(1);
  const handleClose = () => {
    setIsOpen(false);
  };

  const [selectedFiles, setSelectedFiles] = React.useState<Item[]>([]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="flex h-[80vh] max-h-[600px] w-full max-w-[60vw] flex-grow flex-col">
        <DialogHeader>
          <DialogTitle>
            {step === 1 && "Create Group"}
            {step === 2 && "Reorder Files"}
          </DialogTitle>
        </DialogHeader>
        {step === 1 && (
          <AddGroupModalContentStep1
            handleClose={handleClose}
            setStep={setStep}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
          />
        )}
        {step === 2 && (
          <AddGroupModalContentStep2
            handleClose={handleClose}
            setStep={setStep}
            parentFolderId={parentFolderId}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
